import { ChangeDetectorRef } from '@angular/core';
import { Breakpoints } from '@rd-lib/breakpoints';
import * as CSS from 'csstype';

export enum ViewPortType {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
}

export interface ResponsiveSrcset {
  mobile: string;
  mobile2x: string;
  tablet?: string;
  tablet2x?: string;
  desktop: string;
  desktop2x: string;
}

interface ResponsiveBackgroundImage {
  devicePixelRatio: number;
  viewPortType: ViewPortType;
  srcset: ResponsiveSrcset;
}

/**
 *
 * @param viewPortType device's view port type
 */
export function responsiveBackgroundImage({
  devicePixelRatio,
  viewPortType,
  srcset,
}: ResponsiveBackgroundImage): CSS.Properties {
  const { mobile, mobile2x, desktop, desktop2x } = srcset;
  // By default, tablet and tablet2x will follow desktop image, but can override
  const tablet = srcset.tablet ?? srcset.desktop;
  const tablet2x = srcset.tablet2x ?? srcset.desktop2x;

  if (viewPortType === ViewPortType.desktop && devicePixelRatio >= 2) {
    return {
      backgroundImage: `url(${desktop2x})`,
    };
  } else if (viewPortType === ViewPortType.desktop) {
    return {
      backgroundImage: `url(${desktop})`,
    };
  } else if (viewPortType === ViewPortType.tablet && devicePixelRatio >= 2) {
    return {
      backgroundImage: `url(${tablet2x})`,
    };
  } else if (viewPortType === ViewPortType.tablet) {
    return {
      backgroundImage: `url(${tablet})`,
    };
  } else if (viewPortType === ViewPortType.mobile && devicePixelRatio >= 2) {
    return {
      backgroundImage: `url(${mobile2x})`,
    };
  } else {
    return {
      backgroundImage: `url(${mobile})`,
    };
  }
}

export function detectViewPort(
  cdRef: ChangeDetectorRef,
  viewPortType: ViewPortType,
  innerWidth: number,
  onChange: (viewPortType: ViewPortType) => void,
): ViewPortType {
  let newViewPortType = ViewPortType.mobile;

  if (innerWidth >= Breakpoints.DESKTOP) {
    newViewPortType = ViewPortType.desktop;
  } else if (
    innerWidth < Breakpoints.DESKTOP &&
    innerWidth >= Breakpoints.TABLET
  ) {
    newViewPortType = ViewPortType.tablet;
  } else {
    newViewPortType = ViewPortType.mobile;
  }

  if (newViewPortType !== viewPortType) {
    onChange(newViewPortType);
    cdRef.detectChanges();
  }

  return newViewPortType;
}
